import {svgIconWrapper} from '../svg-icon-wrapper';

import RecurringRegular from './recurring-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <RecurringRegular {...validProps} />;
}

SvgComponent.iconName = 'recurring-regular';

export const RecurringRegularIcon = svgIconWrapper(SvgComponent);
